import React, { useState, useEffect } from 'react';
import { AlertCircle, Clock } from 'lucide-react';

const SessionTimeoutWarning = ({ onTimeout, warningTime = 5 * 60 * 1000 }) => {
  const [showWarning, setShowWarning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(warningTime / 1000);

  useEffect(() => {
    // Start warning timer
    const warningTimer = setTimeout(() => {
      setShowWarning(true);
      setTimeLeft(warningTime / 1000);
    }, warningTime);

    // Cleanup
    return () => clearTimeout(warningTimer);
  }, [warningTime]);

  useEffect(() => {
    if (!showWarning) return;

    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          onTimeout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [showWarning, onTimeout]);

  if (!showWarning) return null;

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="mb-4 p-3 bg-warning-50 border border-warning-200 rounded-lg">
      <div className="flex items-center text-warning-700">
        <AlertCircle size={16} className="mr-2" />
        <span className="text-sm font-medium">Session Timeout Warning</span>
      </div>
      <div className="mt-1 flex items-center text-warning-600">
        <Clock size={14} className="mr-1" />
        <span className="text-xs">
          Your session will expire in {minutes}:{seconds.toString().padStart(2, '0')}
        </span>
      </div>
    </div>
  );
};

export default SessionTimeoutWarning;